export default "__VITE_ASSET__y8iSK4hj__"